<template>
    <div id="content">
        <loader></loader>
        <div class="top">
            <div class="header">
                <h1>{{customer.company}} - {{questionnaire.reason.label}} - Questionnaire </h1>
                <div class="pageOptions">
                    <btn text="Enregistrer" ico="valide" @click="save"
                         v-if="$store.getters.hasPerm('response:add/edit') && !isLocked && !preview"></btn>
                    <btn ico="times" color="red" @click="cancel"
                         v-if="$store.getters.hasPerm('response:add/edit')"></btn>
                </div>
            </div>
            <div v-if="createAt !== 0">
                Répondu le : {{createAt|formatDateHour}}
            </div>
        </div>
        <div class="double" ref="responseTop">
            <form class="responses" ref="responses">
                <Question v-for="(question,k) in questions" :key="k" :k="k" :question="question"
                          :response="responses[k]" :locked="isLocked"
                          v-if="condition(question,k)"></Question>
            </form>
            <div class="response-resume">
                <div class="response-content" :style="{top:resumeTop+'px'}">
                    <h3>Résumé</h3>
                    <div v-for="(question,k) in questions" class="resume" v-if="resume(question,k)">
                        <p class="title" v-html="showQuestionText(question)"></p>
                        <p class="response">{{showResponses(question,k)}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import tools from '../config.ts';
    import Btn from "@/components/Btn";
    import Loader from "@/components/Loader";
    import Question from "@/components/response/Question";
    import anime from "animejs";

    export default {
        name: "Response",
        components: {Question, Loader, Btn},
        data() {
            return {
                questionnaireId: 0,
                customerId: 0,
                responseId: 0,

                questionnaire: {reason: {}},
                questions: {},
                responses: [],
                customer: {},
                preview: false,

                createAt: 0,
                resumeTop:0,
            }
        },
        methods: {

            load() {

                axios.get(tools.api("questionnaire/" + this.questionnaireId), tools.headerGET())
                    .then((response) => {
                        this.questionnaire = response.data;
                        this.questions = JSON.parse(this.questionnaire.questions);

                        if (this.responseId) {
                            this.loadResponse();
                            return;
                        }

                        tools.loader(false);
                        this.questions.forEach((question) => {
                            let values = [];
                            question.content.forEach((content) => {
                                values.push("");
                            })
                            this.responses.push({
                                question: question.id,
                                value: values,
                            })
                        });

                    })
                    .catch((e) => {
                        tools.loader(false);
                    })
            },
            loadResponse() {

                axios.get(tools.api("customer/" + this.customerId + "/questionnaire/" + this.questionnaireId + "/response/" + this.responseId), tools.headerGET())
                    .then((response) => {

                        tools.loader(false);

                        this.createAt = response.data.createAt;
                        this.responses = JSON.parse(response.data.responses);
                    })
            },
            loadCustomer() {
                axios.get(tools.api("customer/" + this.customerId), tools.headerGET())
                    .then((response) => {
                        this.customer = response.data;
                    })
            },

            save() {

                let responses = JSON.stringify(this.responses);

                console.log(responses);

                let url = "response";
                if (this.responseId) {
                    url += "/" + this.responseId
                }

                let datas = {
                    customer_id: this.customerId,
                    questionnaire_id: this.questionnaireId,
                    responses: responses
                }

                axios.post(tools.api(url), tools.toPOST(datas), tools.headerPOST())
                    .then((response) => {

                        tools.loader(false);

                        if (!tools.isSuccessResponse(response)) {
                            return tools.popup("valid", {
                                title: "Erreur",
                                message: "Erreur lors de l'enregistrement des réponses",
                            });
                        }

                        if (!this.responseId) {
                            this.$store.commit("setResponseId", response.data.response_id);
                            this.$router.push("/call/add");
                        } else {
                            this.$router.push("/customer/" + this.customerId + "/questionnaires/" + this.questionnaireId + "/reponses")
                        }
                    })
                    .catch((error) => {
                        tools.loader(false);
                        tools.popup("valid", {
                            title: "Erreur",
                            message: "Erreur lors de l'enregistrement des réponses. <br/><br/>Détail de l'erreur : <br/>" + tools.parseError(error)
                        })
                    })
            },
            cancel() {

                if (this.isLocked) {
                    this.$router.back();
                    return
                }

                tools.popup("confirm", {
                    title: "Confirmation",
                    message: "Voulez-vous vraiment annuler les réponses ?",
                    success: () => {
                        this.$router.back();
                    }
                })
            },
            condition(question, k) {

                let debug = false;

                // if(question.id === -6){
                //     debug = true;
                // }else{
                //     debug = false
                // }

                if (debug) {
                    console.log("---------------------")
                    console.log("questionId : " + question.id)
                    console.log("conditions.length : " + question.conditions.length);
                }

                if (question.conditions.length <= 0) {
                    question.show = true;
                    return question.show;
                }

                let pattern = question.pattern || ""; // (condition_1 ET condition_2) OU condition_3
                let responses = {};

                let prevShow = question.show;
                question.show = false;

                // for each condition in the question
                question.conditions.forEach((condition, key) => {

                    let quest = this.getQuestionById(condition.question);
                    let response = this.getResponseByQuestionId(condition.question);

                    responses[key] = false;

                    if (!response) {
                        return;
                    }
                    if (debug) {
                        console.log("---")
                        console.log("question Id : " + condition.question)
                        console.log("key : " + key)
                        console.log("condition.responses.equal : " + condition.responses.equal)
                        console.log("condition.responses.value : " + condition.responses.value)
                        console.log(condition)
                        console.log("response.value : " + JSON.stringify(response.value))
                        console.log("question.show : " + quest.show)
                    }

                    if (!condition.responses.value) {
                        condition.responses.value = "";
                    }

                    if (!question.pattern) {
                        pattern += " condition_" + (key + 1) + " ET ";
                    }


                    if (!quest.show) {
                        return;
                    }

                    let value = condition.responses.value;
                    value = value.replace(/\(/g, "\\(");
                    value = value.replace(/\)/g, "\\)");
                    value = value.replace(/\[/g, "\\[");
                    value = value.replace(/\]/g, "\\]");
                    value = value.replace(/\-/g, "\\-");
                    value = value.replace(/\+/g, "\\+");
                    value = value.replace(/\*/g, "\\*");

                    let regex = new RegExp(value);

                    response.value.forEach((value) => {

                        switch (condition.responses.equal) {
                            case "equal":
                                if (debug) {
                                    console.log("equal : " + value + " === " + condition.responses.value)
                                }
                                if (value == condition.responses.value) {
                                    if (debug) {
                                        console.log("is equal : key : " + key)
                                    }
                                    responses[key] = true;
                                }
                                break;
                            case "contain":
                                if (value.match(regex)) {
                                    responses[key] = true;
                                }
                                break;
                            case "not-equal":
                                if (value != condition.responses.value) {
                                    responses[key] = true;
                                }
                                break;
                            case "not-contain":
                                if (!value.match(regex)) {
                                    responses[key] = true;
                                }
                                break;
                        }
                    })
                });

                if (!question.pattern && pattern !== "") {
                    pattern = pattern.substr(0, pattern.length - 4);
                }

                if (debug) {
                    console.log("-----")
                    console.log("responses : " + JSON.stringify(responses))
                    console.log("pattern : " + pattern)
                }

                let Ors = pattern.split("OU");

                Ors.forEach((Or) => {

                    let Ands = Or.split("ET");
                    let total = 0;

                    Ands.forEach((And) => {

                        let condition = parseInt(And.replace(/[condit_(]+(\d)\)?/, "$1").trim());
                        let conditionKey = (condition - 1).toString();

                        if (debug) {
                            console.log("condition : " + And)
                            console.log("responses[" + conditionKey + "] : " + responses[conditionKey])
                        }

                        if (responses[conditionKey]) {
                            total++;
                        }
                    });

                    if (debug) {
                        console.log("total : " + total)
                        console.log("Ands.length : " + Ands.length)
                    }

                    if (Ands.length > 0 && total === Ands.length) {
                        question.show = true;
                    }
                });

                if (debug) {
                    console.log("resposnes : " + JSON.stringify(this.responses))
                }

                if (question.show && !prevShow) {
                    let scrollTop = this.$refs.responses.offsetHeight - window.scrollY
                    anime({
                        targets: ['#content'],
                        scrollTop: scrollTop,
                        duration: 1500,
                        easing: "easeOutExpo",
                    });
                    anime({
                        targets: ['.response-content'],
                        scrollTop: scrollTop,
                        duration: 1500,
                        easing: "easeOutExpo",
                    })
                }

                return question.show;

            },
            resume(question, k) {
                if (!question.show) {
                    return false;
                }

                if (!question.resume) {
                    return false;
                }

                let response = this.getResponseByQuestionId(question.id);
                console.log("------------[" + question.id + "]-----------------");
                for (let i = 0; i < response.value.length; i++) {
                    console.log(response.value[i]);
                    if (response.value[i] !== "") {
                        return true;
                    }
                }

                return false;
            },
            showResponses(question, k) {
                let response = this.getResponseByQuestionId(question.id);

                let res = "";
                response.value.forEach((val) => {
                    if (val !== "") {
                        res += val + ", ";
                    }
                });

                res = res.substr(0, res.length - 2);
                return res;
            },
            showQuestionText(question) {
                if (question.labelText) {
                    return question.labelText;
                }
                return question.label
            },
            getQuestionById(questionId) {
                return this.questions.filter((question) => question.id === questionId)[0]
            },
            getResponseByQuestionId(questionId) {
                return this.responses.filter((response) => response.question === questionId)[0]
            },
            isCheckbox(question) {
                return question.type === 'checkbox' || question.type === 'radio' || question.type === 'select';
            }
        },
        computed: {

            isLocked() {
                return this.responseId > 0;
            }

        },
        watch: {
            responses(val) {
                // console.log(val)
            }
        },
        mounted() {

            if (!this.$store.getters.hasPerm('response:add/edit')) {
                return this.$router.back();
            }

            this.questionnaireId = this.$route.params.questionnaire_id;
            this.customerId = this.$route.params.customer_id;
            this.responseId = this.$route.params.response_id;

            if (this.responseId === "preview") {
                this.responseId = 0;
                this.preview = true;
            }

            this.$store.commit("onEditMode", true);

            tools.loader(true);

            tools.$on("newResponse", (key, value) => {
                this.$set(this.responses, key, value);
            })

            this.resumeTop = this.$refs.responseTop.getBoundingClientRect().top;

            this.load();
            this.loadCustomer();
        }
    }
</script>